<template>
    <div>
        <div class="box-body">
            <ul class="products-list product-list-in-box overff">
                <li class="item" v-for="(x, index) in data" :key="index">
                    <div class="row">
                      <div class="col-md-5">
                        <div class="product-img">
                            <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                            <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="img-circle">
                            <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="img-circle">
                            <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="img-circle">
                        </div>
                        <!-- postprofile -->
                        <div class="product-info" v-if="postprofile==true">
                            <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                            </a>
                            <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Designation : </span>
                                {{x.designation}}
                            </span>
                        </div>
                        <!-- interestRec -->
                        <div class="product-info" v-if="interestRec==true">
                          <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                          </a>
                          <span class="product-description" :title="x.interviewer_interest_date | formatDatetimea"><span class="skill-lable">Applied on : </span>
                            <span style="color:#999;font-weight: 400;">{{x.interviewer_interest_date | formatDatetimea }}</span>
                          </span>
                        </div>
                        <!-- interestSend -->
                        <div class="product-info" v-if="interestSend==true">
                          <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                          </a>
                          <span class="product-description" :title="x.org_interest_date | formatDatetimea"><span class="skill-lable">Interested on : </span>
                            <span style="color:#999;font-weight: 400;">{{x.org_interest_date | formatDatetimea }}</span>
                          </span>
                        </div>
                        <!-- tobeschedule -->
                        <div class="product-info" v-if="tobeschedule==true">
                          <a href="javascript:void(0)" @click="showModal(x._id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                          </a>
                          <span class="product-description" :title="x.interviewer_interest_date | formatDatetimea"><span class="skill-lable">Applied on : </span>
                            <span style="color:#999;font-weight: 400;">{{x.interviewer_interest_date | formatDatetimea }}</span>
                          </span>
                        </div>
                        <!-- schedule -->
                        <div class="product-info" v-if="schedule==true">
                          <a href="javascript:void(0)" @click="showModal(x.user_id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                          </a>
                          <span class="product-description" :title="x.interviewer_interest_date | formatDatetimea"><span class="skill-lable">Applied on : </span>
                            <span style="color:#999;font-weight: 400;">{{x.interviewer_interest_date | formatDatetimea }}</span>
                          </span>
                        </div>
                        <!-- result -->
                        <div class="product-info" v-if="result==true">
                          <a href="javascript:void(0)" @click="showModal(x.user_id)" class="product-title name">{{x.first_name}} {{x.last_name}}
                          </a>
                          <span class="product-description" :title="x.interviewer_interest_date | formatDatetimea"><span class="skill-lable">Applied on : </span>
                            <span style="color:#999;font-weight: 400;">{{x.interviewer_interest_date | formatDatetimea }}</span>
                          </span>
                        </div>
                      </div>
                      <!-- postprofile -->
                      <div class="col-md-4" v-if="postprofile==true">
                        <button v-if="!showRole" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="col-md-3" v-if="postprofile==true">
                        <span class="direct-chat-timestamp f12" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                      </div>
                      <!-- interestRec, interestSend -->
                      <div class="col-md-4" v-if="interestRec==true || interestSend==true" @click="showSheduledetails(x._id,x.statusval)">
                        <button class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="col-md-3" v-if="interestRec==true || interestSend==true" @click="showSheduledetails(x._id,x.statusval)">
                        <span class="direct-chat-timestamp f12" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                      </div>
                      <!-- tobeschedule,schedule -->
                      <div class="col-md-4" v-if="tobeschedule==true || schedule==true">
                        <button v-if="!showRole" @click="showSheduledetails(x._id,x.statusval)" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="col-md-3" v-if="tobeschedule==true || schedule==true">
                        <span class="direct-chat-timestamp f12" @click="showSheduledetails(x._id,x.statusval)" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                      </div>
                      <!-- result -->
                      <div class="col-md-4" v-if="result==true">
                        <button v-if="!showRole" @click="showResult(x._id,x.user_id)" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="col-md-3" v-if="result==true">
                        <span class="direct-chat-timestamp f12" @click="showResult(x._id,x.user_id)" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(x.interviewer_rating)" :read-only="true"></star-rating></span>
                      </div>
                    </div>
                    <!-- schedule -->
                    <div class="direct-chat-info clearfix mt-2 ml-5" v-if="schedule==true" @click="showShedule1(x._id,x.user_id)">
                      <span class="direct-chat-timestamp pull-left">Candidate Name : <span style="color:black"> {{x.candidate_name}} {{x.candidate_lastname}}</span></span>
                      <span class="direct-chat-timestamp pull-right" style="width:27%;color: #60AB2F;"><i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(x.startdatetime_utc)}} to {{ getTime(x.enddatetime_utc)}} {{currentTimezone}} </span>
                      <span class="direct-chat-timestamp pull-right" style="width:20%;color: #60AB2F;"><i class="fa fa-calendar" aria-hidden="true"></i> {{getDate(x.startdatetime_utc)}}</span>
                    </div>
                    <!-- result -->
                    <div class="direct-chat-info clearfix mt-2 ml-5" v-if="result==true" @click="showResult(x._id,x.user_id)">
                      <span class="direct-chat-timestamp pull-left ml-5">Skillset : <span style="color:black">{{x.userskillnames}}</span></span>
                      <span class="direct-chat-timestamp pull-right" style="width:27%;color: #60AB2F;"><i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(x.startdatetime_utc)}} - {{getTime(x.enddatetime_utc)}} {{currentTimezone}}</span>
                      <span class="direct-chat-timestamp pull-right" style="width:20%;color: #60AB2F;"><i class="uil uil-calender" aria-hidden="true"></i> {{getDate(x.startdatetime_utc)}}</span>
                    </div>
                    <!-- postprofile -->
                    <div class="row mt-2"  v-if="postprofile==true">
                      <div class="col-md-6">
                          <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                              {{x.userskillnames}}
                          </span>
                      </div>
                      <div class="col-md-3">
                          <span class="direct-chat-timestamp mt-2 wishlist pull-right"><a class="tc"><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                      </div>
                      <div class="col-md-3 tc myseek">
                          <label for="" v-if="showRole">{{x.availability_req_status}}</label>
                          <button v-if="showRole" data-toggle="modal" data-target="#seekTime1" @click="submitRequest(index, x._id)" class="btn btn-primary btn-sm pull-right"><i class="uil uil-clock" aria-hidden="true"></i> Seek Time </button>
                          <button v-if="showRole && x.availability_tag == 'yes'" @click="showShedule(x._id)" class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Schedule</button>
                          <button v-if="showRole && x.availability_tag == 'no' && x.send_availability_mail == 'yes'" disabled class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Schedule</button>
                          <button v-if="!showRole" @click="interestRequest(x._id, 1)" class="btn btn-success btn-sm pull-right"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Interest</button>
                      </div>
                    </div>
                    <!-- interestRec -->
                    <div class="row mt-2" v-if="interestRec==true">
                      <div class="col-md-5" @click="showSheduledetails(x._id,x.statusval)">
                        <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                          {{x.userskillnames}}
                        </span>
                      </div>
                      <div class="col-md-2 p-1">
                        <span class="direct-chat-timestamp mt-2 wishlist pull-right"><a><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                      </div>
                      <div class="col-md-3 mt-2 p-1">
                        <a @click="showReason(x._id)" v-if="x.statusval !='Declined' && x.status !='Accepted' && x.statusval !='cancelled'" class="direct-chat-timestamp pull-right" style="color:red;cursor: pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</a>
                      </div>
                      <div class="col-md-2 p-1">
                        <a v-if="x.status =='Accept' && (x.statusval =='' || x.statusval ==null)" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right" @click="interestRequest(x._id, 2)"><i class="fa fa-check" aria-hidden="true"></i>Accept</a>
                        <span v-if="x.status =='Accepted' && (x.statusval =='' || x.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='Declined'" class="pull-right" style="color:#ff2627"> Declined</span>
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='cancelled'" class="pull-right" style="color:#ff2627">Cancelled</span>
                      </div>
                    </div>
                    <!-- interestSend -->
                    <div class="row mt-2" v-if="interestSend==true">
                      <div class="col-md-5" @click="showSheduledetails(x._id,x.statusval)">
                        <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                        {{x.userskillnames}}
                      </span>
                      </div>
                      <div class="col-md-4">
                        <span class="direct-chat-timestamp ml-1 wishlist" style="width: 28%;"><a><i class="fa fa-bookmark" aria-hidden="true"></i> Bookmark</a></span>
                      </div>
                      <div class="col-md-3 tc">
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.status =='Accepted' && (x.statusval =='' || x.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='Declined'" class="pull-right" style="color:#ff2627">Declined</span>
                        <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.statusval =='cancelled'" class="pull-right" style="color:#ff2627"> Cancelled</span>
                        <button v-if="x.status =='uninterest' && (x.statusval =='' || x.statusval ==null)" @click="showconfirmation(x._id)" class="btn btn-success btn-sm pull-right"><i class="fa fa-thumbs-o-down" aria-hidden="true"></i> Uninterest</button>
                      </div>
                    </div>
                    <!-- tobeschedule -->
                    <div class="row mt-2" v-if="tobeschedule==true">
                      <div class="col-md-5" @click="showSheduledetails(x._id,x.statusval)">
                        <span class="product-description ml-5" :title="x.userskillnames"><span class="skill-lable">Skillset : </span>
                        {{x.userskillnames}}
                      </span>
                      </div>
                      <div class="col-md-7 tc">
                        <div class="seekTime">
                          <div v-if="x.status !='cancelled' && selectdata.isclient =='no'">
                            <div class="myseektime">
                              <label v-if="Boolean(showRole)" for="">{{x.availability_req_status}}</label>
                              <button v-if="Boolean(showRole)" data-toggle="modal" data-target="#seekTime1" @click="submitRequest(index, x._id)" class="btn btn-primary btn-sm pull-right seekbtn"><i class="uil uil-clock" aria-hidden="true"></i> Seek Time</button>
                              <button class="btn btn-success btn-sm pull-right" @click="showShedule(x._id)"><i class="fa fa-calendar" aria-hidden="true"></i> Schedule</button>
                            </div>
                            <span v-if="x.status !='cancelled' && selectdata.isclient =='no' && x.schedule_count < 1" @click="showReason(x._id)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer"><i class="fa fa-times" aria-hidden="true"></i> cancel</span>
                            <span @click="showSheduledetails(x._id,x.statusval)" v-if="x.status =='cancelled'" class="pull-right" style="color:#ff2627"> Cancelled</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- schedule -->
                    <div class="direct-chat-info clearfix  ml-5" v-if="schedule==true">
                      <span @click="showShedule1(x._id,x.user_id)" v-if="x.status == 'Reschedule Request Pending'" class="direct-chat-timestamp pull-left requested-pending-l"> Reschedule Request Pending</span>
                      <span @click="showShedule1(x._id,x.user_id)" v-if="x.reschedule_by !=null && x.status =='Reschedule Requested' && x.req_new_time =='interviewer'" class="direct-chat-timestamp pull-left requested-l" style="color:#563CFF;background-color:#F9ECFF;"> Requested New Time</span>
                      <span @click="showShedule1(x._id,x.user_id)" v-if="x.status =='Reschedule Requested' && x.req_new_time !='interviewer'" class="direct-chat-timestamp pull-left requested-l"> Reschedule Requested</span>
                      <span @click="showShedule1(x._id,x.user_id)" v-if="x.status =='Schedule Request'" class="direct-chat-timestamp pull-left requested-l" style="color:#67E91A;background-color:#F2FEEB;"> Schedule Request Pending</span>
                      <span v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" class="direct-chat-timestamp pull-left requested-l" style="color:#67E91A;background-color:#F2FEEB;"> New Time Requested </span>
                      <div>
                        <button :disabled="checkingdate(x.startdatetime_utc, x.enddatetime_utc) == 'no'" v-if="x.status == 'Open' && selectdata.isclient =='no'" class="btn connectbtn btn-sm pull-right" @click="connect(x.meeting_id,x._id,x.user_id, x)"> Connect</button>
                        <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.req_new_time !='interviewer'" class="btn sbtn btn-sm pull-right" @click="getavailabledate(x.user_id,x)">Schedule</button>
                        <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by !=null && x.req_new_time =='interviewer'" @click="getavailabledate(x.user_id,x)" class="btn sbtn btn-sm pull-right">Schedule</button>
                        <button v-if="selectdata.isclient =='no' && x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" @click="getavailabledate(x.user_id,x)" class="btn sbtn btn-sm pull-right">Schedule</button>
                        <span v-if="x.status == 'Cancelled'" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Cancelled</span>
                        <span v-if="x.status == 'Declined'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Declined</span>
                        <span v-if="x.status == 'Auto-Declined'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;background-color:#F5F5F5;padding:0 6px;border-radius:12px;"> Auto Declined</span>
                        <span v-if="x.status == 'Expired'" class="direct-chat-timestamp pull-right mt-2" style="color:#fff;margin-right: 10px;background-color:#E74E4E;padding:0 6px;border-radius:12px;"> Expired</span>
                        <span v-if="x.status == 'Accepted'" @click="openInfo(x)" class="direct-chat-timestamp pull-right mt-2" style="color:#fff;margin-right: 10px;background-color:rgb(96 171 47);padding:0 6px;border-radius:12px;"> Accepted</span>
                      </div>
                      <div v-if="selectdata.isclient =='no'">
                        <span v-if="x.status == 'Open' && x.reschedule_by ==null && x.req_new_time !='interviewer'" @click="getavailabledate(x.user_id,x)" class="direct-chat-timestamp pull-right mt-2" style="color:#60ab2f;margin-right: 10px;cursor:pointer;"><i class="fa fa-history" aria-hidden="true"></i> Reschedule</span>
                        <span v-if="x.status == 'Open' || x.status == 'Accepted' || x.status =='Schedule Request'" @click="showReason2(x.user_id,x._id)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Cancel</span>
                        <span v-if="x.status == 'Reschedule Request Pending'" @click="showReason1(x.user_id,x._id,1)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Cancel</span>
                        <span v-if="x.status =='Reschedule Requested' && x.req_new_time !='interviewer'" @click="showReason1(x.user_id,x._id,1)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                        <span v-if="x.status =='Reschedule Requested' && x.reschedule_by !=null && x.req_new_time =='interviewer'" @click="showReason1(x.user_id,x._id,2)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                        <span v-if="x.status == 'Reschedule Requested' && x.reschedule_by ==null && x.req_new_time =='interviewer'" @click="showReason1(x.user_id,x._id,3)" class="direct-chat-timestamp pull-right mt-2" style="color:red;margin-right: 10px;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Decline</span>
                      </div>
                    </div>
                    <!-- result -->
                    <div class="direct-chat-info clearfix ml-5" v-if="result==true">
                      <div>
                        <span class="direct-chat-timestamp pull-left ml-5">Candidate Name : <span style="color:black"> {{x.candidate_name}} {{x.candidate_lastname}}</span></span>
                        <button type="button" @click="showResult(x._id,x.user_id)" class="btn btn-default btn-flat btn-sm b-c result pull-right">View Result    <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                        <span v-if="x.feedback_status =='Completed'" class="result-status-p pull-right">Completed</span>
                        <span v-if="x.feedback_status =='Pending'" class="result-status-c pull-right">Pending</span>
                      </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="modal fade" id="seekTime1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title closebtnmodel" id="exampleModalLabel"><strong>Seek Time Request</strong> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button></h4>
                </div>
                <div class="modal-body txtarea">
                    <label for="">Remarks*</label>
                    <textarea  placeholder="Enter the remarks" class="invalid-feedback" name="" id="" cols="100" rows="5" v-model="comments"></textarea>
                    <span style="color:red">{{remarkAlert}}</span>
                </div>
                <br>
                <div class="modal-footer introBtn">
                    <button type="button" class="btn " data-dismiss="modal">Close</button>
                    <button type="button" class="btn saveaccdetialsbtn"  v-on:click="seekTime()">Submit</button>
                </div>
                </div>
            </div>
        </div>
        <div v-show="Boolean(showconfirm)" class="modal fade in" id="modal-default" style="display: block; padding-right: 17px;">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <h5 style="font-weight: 600;">Uninterest Confirmation</h5>
                <hr>
                <div style="text-align:center;margin-top: 30px;">Are you sure you want to cancel this profile?</div>
              </div>
              <div class="modal-footer" style="border-top-color: #ffffff;">
                <button type="button" @click="close()"  class="btn btn-default"> No</button>
                <button type="button" @click="uninterestRequest()"  class="btn btn-success"> Yes</button>

              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <div class="modal fade" id="myModal1A">
          <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
            <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
              <div class="modal-body" style="padding:0px">
                <div class="row" >
                  <div class="col-md-12 " style="padding:17px">
                    <div class="col-md-12" style="text-align: center;">
                      <p style="font-size: 20px;font-weight: 400;">{{infoName}}</p><br>
                      <button class="btn btn-success" @click="closeViolated()">Ok</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
        </div>
        <add-shedule v-model="shwovalue" :shwovalueAddSchedule="shwovalue" v-if="shwovalue"></add-shedule>
        <profile-modal v-model="modalOpen" :shwovalueProfileProfile="modalOpen" v-if="modalOpen"></profile-modal>
        <schedule-details v-model="sheduledetailsOpen" :shwovalueScheduleDetails="sheduledetailsOpen" v-if="sheduledetailsOpen"></schedule-details>
        <reason-popup v-model="reasonOpen" :shwovalueReason="reasonOpen" v-if="reasonOpen"></reason-popup>
        <ScheduleDetails v-model="sheduleOpen" :shwovalueScheduleDetails="sheduleOpen" v-if="sheduleOpen"></ScheduleDetails>
        <ResultShow v-model="resultOpen" :shwovalueResultResult="resultOpen" v-if="resultOpen"></ResultShow>
    </div>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import { BaseURL } from '../../shared/classes'
import StarRating from 'vue-star-rating'
import ProfileModal from '../Feature/profileDetails'
import $ from 'jquery'
import AddShedule from '../Feature/addshedule'
import ScheduleDetails from '../Feature/scheduledetail'
import ReasonPopup from '../Feature/reasonpopup'
import momentsone from 'moment-timezone'
import moment from 'moment'
import * as Cookies from 'js-cookie'
import router from '../../router/index'
import ResultShow from '../Feature/result_popup'
Vue.use(moment)
export default {
  props: [
    'postprofile',
    'data',
    'showRole',
    'selectpost',
    'interestRec',
    'interestSend',
    'tobeschedule',
    'selectdata',
    'schedule',
    'currentTimezone',
    'result'
  ],
  data () {
    return {
      viewid: [],
      modalOpen: false,
      base_urls: BaseURL,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      remarkAlert: '',
      seekindex: '',
      comments: '',
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      seektimemsg: '',
      tempId: '',
      shwovalue: false,
      sheduledetailsOpen: false,
      reasonOpen: false,
      profileid: '',
      showconfirm: false,
      currentTimeZone: momentsone.tz.guess(),
      timezone: momentsone.tz.guess(),
      sheduleOpen: false,
      current_date: '',
      infoName: '',
      resultOpen: false
    }
  },
  components: {
    StarRating,
    ProfileModal,
    AddShedule,
    ScheduleDetails,
    ReasonPopup,
    ResultShow
  },
  methods: {
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.modalOpen = true
    },
    submitRequest (index, _id) {
      this.tempId = _id
      this.seekindex = index
    },
    seekTime (_id) {
      if (this.comments === '' || this.comments === undefined) {
        this.remarkAlert = 'Remarks is required*'
        this.submitted = false
      } else {
        this.submitted = true
        this._id = this.userInfo._id
        const formData = {
          user_id: this.tempId,
          org_id: this._id,
          comments: this.comments
        }
        axios.post(this.base_urls + '/dashboard/add_seektime', { formData: formData }, this.config).then(response => {
          this.seektimemsg = response.data.message
          if (this.seektimemsg === 'Success') {
            $('#seekTime1').modal('hide')
            this.data[this.seekindex].availability_req_status = 'Availability Requested'
          }
        }).catch(e => {
        // router.push({ name: 'Login' })
        })
      }
    },
    showShedule (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.shwovalue = true
    },
    showShedule1 (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('sid', JSON.stringify(id))
      this.sheduleOpen = true
    },
    showResult (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('sid', JSON.stringify(id))
      this.resultOpen = true
    },
    interestRequest (id, type) {
      var dat = {
        id: id,
        type: type
      }
      this.$emit('interestRequest', dat)
    },
    uninterestRequest () {
      this.showconfirm = false
      this.$emit('uninterestRequest', this.profileid)
    },
    getavailabledate (id, data) {
      var dat = {
        id: id,
        data: data
      }
      this.$emit('getavailabledate', dat)
    },
    showSheduledetails (id, status) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.sheduledetailsOpen = true
    },
    showReason (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('reschedule', JSON.stringify('interest'))
      this.reasonOpen = true
    },
    showReason1 (id, sid, type) {
      this.viewid = id
      if (type === 2) {
        localStorage.setItem('reschedule', JSON.stringify('decline'))
      } else if (type === 3) {
        localStorage.setItem('reschedule', JSON.stringify('decline1'))
      } else {
        localStorage.setItem('reschedule', JSON.stringify('cancel'))
      }
      localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    showReason2 (id, sid) {
      this.viewid = id
      localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.reasonOpen = true
    },
    showconfirmation (id) {
      this.profileid = id
      this.showconfirm = true
    },
    close () {
      this.showconfirm = false
    },
    getDate (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM YYYY')
      return Start
    },
    getTime (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
      return Start
    },
    checkingdate (date, end) {
      var currentDate = new Date()
      this.current_date = moment(String(currentDate)).utc().format('YYYYMMDDHHmm')
      var scheduledate = moment.utc(date).subtract(5, 'minutes').toDate()
      scheduledate = moment.utc(scheduledate).format('YYYYMMDDHHmm')
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      if (this.current_date >= scheduledate && this.current_date < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    openInfo (x) {
      if (x.interviewer_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.first_name + ' ' + x.last_name
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.interviewer_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.first_name + ' ' + x.last_name
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.candidate_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.candidate_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.status === 'Auto-Declined') {
        // this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = 'Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.'
      }
      $('#myModal1A').modal('show')
    },
    closeViolated () {
      $('#myModal1A').modal('hide')
    },
    connect (id, sid, viewid, x) {
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      localStorage.setItem('job_title', x.job_tittle)
      localStorage.setItem('organization', this.userInfo.organization)
      router.push('/agora/meeting')
    }
  }
}
</script>
<style>
.myseek{
    width:100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
    column-gap: 3px;
}
.closebtnmodel{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
}
.txtarea{
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.saveaccdetialsbtn{
    background-color: #5bad2b;
    color: white;
}
.wishlist a {
  color: #999999b8 !important;
}
a {
    color: #333;
}
.modal-header {
    padding: 8px !important;
}
.modal-header {
    padding: 8px;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      /* max-height: calc(100vh - 40px); */
      width: 501px;
  }
}
.myseektime{
   width: 100%;
   display: flex;
    flex-direction: row;
    flex-wrap: wrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      column-gap:3px ;
 }
 .rescheduled-l {
  color: rgb(255, 255, 255);
  background-color: rgb(31, 141, 2);
  padding: 1px 8px 0px;
}
.requested-l {
  color: #1F8D02;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.requested-pending-l {
  color:#42D21E;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.result {
  border: 1px solid #5bad2b !important;
  color: #5bad2b !important;
  margin-left: 6px;
}
.result-status-p {
  background-color: #f5f5f5;
  color: #60AB2F;
  padding: 3px 7px 4px 6px;
  margin-top: 4px;
}
.result-status-c {
  background-color: red;
  color: #fff;
  padding: 3px 7px 4px 6px;
  margin-top: 4px;
}
.btns {
  background-color: white;
  color: #5bad2b;
}
</style>
